import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// PASTE YOUR FIREBASE CONFIG HERE FROM THE FIREBASE CONSOLE
const firebaseConfig = {
 apiKey: "AIzaSyBCfW2PZdvJ_R1v9Dz5lkeBgHoDJ-pEb2k",
  authDomain: "shoebhai-faab6.firebaseapp.com",
  projectId: "shoebhai-faab6",
  storageBucket: "shoebhai-faab6.firebasestorage.app",
  messagingSenderId: "243030829028",
  appId: "1:243030829028:web:4931f069781f606dc949f1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);